const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';
const SAFRIE_SSO_REQUEST_TIMEOUT_MS = 15000;

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message =
    typeof payload.message === 'string'
      ? payload.message
      : '修正依頼システムへのログイン準備に失敗しました。';
  throw new Error(message);
}

export async function createSafrieSsoRedirectUrl(accessToken: string) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, SAFRIE_SSO_REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(`${apiBaseUrl}/api/integrations/safrie-sso/login`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      signal: controller.signal,
    });
    await throwIfNotOk(response);
    const payload = (await response.json()) as { redirectUrl: string };
    return payload.redirectUrl;
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw new Error('修正依頼システムへの接続がタイムアウトしました。時間をおいて再度お試しください。');
    }
    if (error instanceof TypeError) {
      throw new Error('修正依頼システムに接続できませんでした。ネットワークまたはAPI設定を確認してください。');
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
}
